<div class="app-container" data-cy="changelog-page">
  <page-header [title]="'title.changelog'" [fullWidthPageTitle]="true"></page-header>

  <section class="content changelog-page-content">
    <loading-spinner [isLoading]="isLoading" [classesString]="'top-50'"></loading-spinner>

    @if (hasError) {
      <div class="alert alert-danger" role="alert" data-cy="changelog-error">
        {{ 'changelog.error' | translate }}
      </div>
    }

    @if (!isLoading && !hasError) {
      <article class="changelog-content" data-cy="changelog-content" [innerHTML]="changelogHtml"></article>
    }
  </section>
</div>
